import React from 'react';

// This imports the functional component from the previous sample.
import VideoJS from './VideoJS'

function Player({src, type, style, className}) {
  const playerRef = React.useRef(null);

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    preload: 'metadata',
    sources: [{
      src: src,
      type: type || 'video/mp4'
    }]
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    console.log('[Player.js] player', player);
    // You can handle player events here, for example:
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      typeof window !== "undefined" && window?.gtag && window.gtag("event", "video", { 
        'event_category': 'stop',
        'value': src,
        'timestamp': player.currentTime()
       })
    });

    player.on('play', () => {
      typeof window !== "undefined" && window?.gtag && window.gtag("event", "video", { 
        'event_category': 'play',
        'value': src
       })
    })

    player.on('pause', () => {
      typeof window !== "undefined" && window?.gtag && window.gtag("event", "video", { 
        'event_category': 'pause',
        'value': src,
        'timestamp': player.currentTime()
       })
    })
  };

  return (
    <>
      <VideoJS options={videoJsOptions} onReady={handlePlayerReady} style={style} className={className}/>
    </>
  );
}

function AutoPlayer({src, type, style, poster, onBuffPerc}) {
  const playerRef = React.useRef(null);

  const videoJsOptions = {
    autoplay: true,
    muted: true,
    loop: true,
    controls: false,
    fluid: true,
    responsive: true,
    preload: 'metadata',
    sources: [{
      src: src,
      type: type || 'video/mp4'
    }],
    poster
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    // You can handle player events here, for example:
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });

    player.on('progress', checkBuffered);

    function checkBuffered () {
      var buffPerc = player.bufferedPercent();
      onBuffPerc(buffPerc);
    }
  };

  return (
      <VideoJS className={'overflow-hidden h-full autovideo'} style={style} options={videoJsOptions} onReady={handlePlayerReady}/>
  );
}

export {
  Player,
  AutoPlayer
}